import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material'

import BulkPreceptors from 'widgets/preceptors/bulk'
import CreatePreceptor from 'widgets/preceptors/create'
import PreceptorsTable from './table'

const Preceptors = (props) => {
  const { director } = props

  const { firestore } = useFirebase()
  const { getPreceptorsBySchoolId, preceptors } = firestore

  const [rows, setRows] = useState([])
  
  useEffect(() => {
    if (director === undefined) return
    getPreceptorsBySchoolId(director.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [director])

  useEffect(() => {
    if (preceptors === undefined) return

    var data = []
    preceptors.forEach((preceptor) => {
      data.push({
        'id': preceptor['id'],
        'name': preceptor['name'],
        'email': preceptor['email'],
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preceptors])

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Preceptores</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BulkPreceptors director={director} />
          </Grid>
          <Grid item xs={12}>
            <CreatePreceptor director={director} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8} lg={9}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE PRECEPTORES</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <PreceptorsTable rows={rows} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Preceptors